import {Field} from 'formik';
import {Stack} from '@mantine/core';
import {FormikSelect, FormikTextInput} from '@flexinet/ui-components';
import {useChannelOptions} from '../../../billing-providers/hooks/useChannelOptions.ts';

const stateOptions = [
    {value: '', label: 'All States'},
    {value: 'PENDING', label: 'Pending'},
    {value: 'EMITTED', label: 'Emitted'},
    {value: 'FAILED', label: 'Failed'},
    // FNP-814: no 'Retry' option — nothing ever wrote that state, so filtering by it always
    // returned an empty list, which reads as "nothing is retrying". Do not re-add it without
    // a writer.
    {value: 'UNCERTAIN', label: 'Uncertain'},
];

export const FilterFormComponent = () => {
    // FNP-616: channel options are catalog-driven (ENABLED BillingProvider keys). This is an
    // OPTIONAL filter, so prepend an "All Channels" empty option.
    const {options: enabledChannels} = useChannelOptions();
    const channelOptions = [{value: '', label: 'All Channels'}, ...enabledChannels];

    return (
        <Stack gap='md' my='md'>
            <Field
                name='state'
                label='State'
                data={stateOptions}
                component={FormikSelect}
            />
            <Field
                name='channel'
                label='Channel'
                data={channelOptions}
                component={FormikSelect}
            />
            <Field
                name='customerId'
                label='Customer ID'
                component={FormikTextInput}
            />
            <Field
                name='dayStart'
                label='Day Start (ISO)'
                placeholder='2026-06-01T00:00:00.000Z'
                component={FormikTextInput}
            />
            <Field
                name='dayEnd'
                label='Day End (ISO)'
                placeholder='2026-06-02T00:00:00.000Z'
                component={FormikTextInput}
            />
        </Stack>
    );
};
